import { Grid, IconButton, Typography } from "@mui/material";

import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import BaseBox from "../../base/BaseBox/baseBox";
import InfoIcon from '@mui/icons-material/Info';

export default function BoxWithTypography(props) {
    const { t } = useTranslation();

    return (
        <BaseBox
            error={props.error}
            warning={props.warning}
        >
            <Grid container
                spacing={1}
                justifyItems={"flex-start"}
                alignContent={'flex-start'}>
                <Grid item sm={5} xs={5} textAlign={"start"} display={"flex"}>
                    <Typography
                        variant="subtitle2"
                        className="capitalize-first-letter"
                    >
                        {props.label}
                    </Typography>
                </Grid>
                {props.showInfoButton &&
                <Grid sm={1} xs={1} display={"contents"}>
                    <IconButton
                        style={{ border: "solid var(--secondary)" }}
                        onClick={props.handleOpenInformationDialog}
                    >
                        <InfoIcon
                            color="primary"
                        />
                    </IconButton>
                </Grid>}
                <Grid item sm={6} xs={6} />

            </Grid>
            <div style={props.style}>{props.children}</div>
        </BaseBox>
    );
}

BoxWithTypography.propTypes = {
    style: PropTypes.object,
    children: PropTypes.object,
    error: PropTypes.bool,
    showInfoButton : PropTypes.bool,
    handleOpenInformationDialog : PropTypes.func
}


BoxWithTypography.defaultProps = {
    error: false,
    showInfoButton : false
}
